import React from 'react';
import { toJS } from 'mobx';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CustomerSuccessDetailScene from './CustomerSuccessDetailScene';
import CustomerSuccessDetailService from '../services/CustomerSuccessDetailService';

class CustomerSuccessDetailSceneContainer extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      type: PropTypes.string,
      typeId: PropTypes.string,
    }),
  };

  customerSuccessDetailService = new CustomerSuccessDetailService();
  componentDidMount() {
    if (this.props.params.type === 'segment') {
      this.customerSuccessDetailService.loadSegment(this.props.params.typeId);
    }
    if (this.props.params.type === 'distributor') {
      this.customerSuccessDetailService.loadDistributor(this.props.params.typeId);
    }
  }

  render() {
    return (
      <CustomerSuccessDetailScene
        isLoading={
          this.customerSuccessDetailService.fetchSegment.fetching ||
          this.customerSuccessDetailService.fetchDistributor.fetching
        }
        segment={toJS(this.customerSuccessDetailService.segment)}
        distributor={toJS(this.customerSuccessDetailService.distributor)}
        type={this.props.params.type}
        typeId={this.props.params.typeId}
      />
    );
  }
}

export default observer(CustomerSuccessDetailSceneContainer);
